import { updateCategory } from "@wordpress/blocks";
import React from "react";

const updateBlockCategoryIcon = () => {
	updateCategory("magazine-blocks", {
		icon: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect width="24" height="24" fill="white" />
				<path
					d="M12 18.7957H4.60217V5.20432L12 9.82797V18.7957Z"
					fill="#690AA0"
				/>
				<path
					d="M19.4194 18.7957H12V9.82797L19.4194 5.20432V18.7957Z"
					fill="#8D42CE"
				/>
				<path
					d="M24 24H0V0H24V24ZM1.07527 22.9247H22.9247V1.07527H1.07527V22.9247Z"
					fill="#690AA0"
				/>
			</svg>
		),
	});
};

export default updateBlockCategoryIcon;
